import Dashboard from "./components/dashboard/dashboard";
import DirectorySearch from "./components/directory-search/directory-search";
import Home from "./components/home/home";
import MessageStatus from "./components/reports/MessageStatus/MessageStatus";
import SuccessRegistration from "./components/users/RegistrationUser/SuccessRegistration";
import RegistrationUser from "./components/users/RegistrationUser/RegistrationUser";
import UploadUser from "./components/users/UploadUser/UploadUser";
import Users from "./components/users/users";
import Documents from "./components/documents/documents";
import Eula from "./components/users/EULA";
import PreRegistration from "./components/users/RegistrationUser/PreRegistration/PreRegistration";
import SuccessPreRegistration from "./components/users/RegistrationUser/PreRegistration/SuccessPreRegistration";
import PasswordChangePreReg from "./components/users/RegistrationUser/PreRegistration/PasswordChangePreReg";
import Organizations from "./components/organizations/organizations";
import RegistrationOrg from "./components/organizations/RegistrationOrg/RegistrationOrg";
import RegistrationOrgSuccess from "./components/organizations/RegistrationOrg/RegistrationOrgSuccess";
import RegistrationOrgTopLevel from "./components/organizations/RegistrationOrg/RegistrationOrgTopLevel";
import UploadOrg from "./components/organizations/UploadOrg/UploadOrg";
import UploadOrgSuccess from "./components/organizations/UploadOrg/UploadOrgSuccess";
import UploadOrgEmail from "./components/organizations/UploadOrgEmail/UploadOrgEmail";
import UploadOrgEmailSuccess from "./components/organizations/UploadOrgEmail/UploadOrgEmailSuccess";
import UploadStatus from "./components/upload-status/upload-status";
import Emails from "./components/emails/emails";
import Customers from "./components/customers/customers";
import RegCustomer from "./components/customers/RegCustomer";
import SentMessage from "./components/reports/SentMessage/SentMessage";
import ReceivedMessage from "./components/reports/ReceivedMessage/ReceivedMessage";
import DownloadStatus from "./components/reports/DownloadStatus/DownloadStatus";
import SignOut from "./components/account/SignOut";
import UserDeleteActivity from "./components/reports/UserReports/DeleteActivity/UserDeleteActivity/UserDeleteActivity";
import MailboxSize from "./components/reports/UserReports/MailboxSize/MailboxSize";
import MessageForwarding from "./components/reports/UserReports/MessageForwarding/MessageForwarding";
import UserActivity from "./components/reports/UserReports/UserActivity/UserActivity";
import UserStatus from "./components/reports/UserReports/UserStatus/UserStatus";
import ResetPassword from "./components/home/ResetPassword/ResetPassword";
import Welcome from "./components/home/Welcome/Welcome";
import ChangePasswordMain from "./components/account/ChangePasswordMain";
import UserAccountHistory from "./components/reports/UserReports/UserActivity/UserAccountHistory/UserAccountHistory";
import SystemOutage from "./components/shared/SystemOutage";
import UnscheduledOutage from "./components/shared/UnscheduledOutage";
import ScheduledOutage from "./components/shared/ScheduledOutage";
import SuccessUserUpload from "./components/users/UploadUser/SuccessUserUpload";
import RequestNotFound from "./components/shared/RequestNotFound";
import UploadResults from "./components/upload-status/UploadResults";
import ExperianResults from "./components/experian-gateway/experian-results";
import ExperianSSO from "./components/experian-gateway/SSO";
import NotifyApp from "./components/shared/NotifyApp/NotifyApp";
import UploadSummary from "./components/upload-status/UploadSummary";
import RegistrationSysAdmin from "./components/sys-admin/RegistrationSysAdmin";
import SuccessSysAdminRegistration from "./components/sys-admin/SuccessSysAdminRegistration";

const AppRoutes = [
  {
    path: "/",
    element: <Home />,
  },

  { path: "/dashboard", element: <Dashboard /> },
  { path: "/directory-search", element: <DirectorySearch /> },
  { path: "/message-status", element: <MessageStatus /> },
  { path: "/user-registration", element: <RegistrationUser /> },
  { path: "/registration-success", element: <SuccessRegistration /> },
  { path: "/user-upload", element: <UploadUser /> },
  { path: "/user-upload-success", element: <SuccessUserUpload /> },
  { path: "/users", element: <Users /> },
  { path: "/documents", element: <Documents /> },
  { path: "/eula", element: <Eula /> },
  { path: "/pre-registration", element: <PreRegistration /> },
  { path: "/success-pre-registration", element: <SuccessPreRegistration /> },
  {
    path: "/password-change-preRegistration",
    element: <PasswordChangePreReg />,
  },
  { path: "/organizations", element: <Organizations /> },
  { path: "/organization-registration", element: <RegistrationOrg /> },
  { path: "/org-registration-success", element: <RegistrationOrgSuccess /> },
  { path: "/toplevel-org-registration", element: <RegistrationOrgTopLevel /> },
  { path: "/upload-organization", element: <UploadOrg /> },
  { path: "/upload-org-success", element: <UploadOrgSuccess /> },
  { path: "/upload-org-email", element: <UploadOrgEmail /> },
  { path: "/upload-org-email-success", element: <UploadOrgEmailSuccess /> },
  { path: "/upload-status", element: <UploadStatus /> },
  { path: "/upload-results", element: <UploadResults /> },
  { path: "/upload-summary", element: <UploadSummary /> },
  { path: "/emails", element: <Emails /> },
  { path: "/customer-registration", element: <RegCustomer /> },
  { path: "/customers", element: <Customers /> },
  { path: "/sent-message", element: <SentMessage /> },
  { path: "/received-message", element: <ReceivedMessage /> },
  { path: "/download-status", element: <DownloadStatus /> },
  { path: "/signout", element: <SignOut /> },
  { path: "/delete-user-activity", element: <UserDeleteActivity /> },
  { path: "/mailbox-size", element: <MailboxSize /> },
  { path: "/message-forwarding", element: <MessageForwarding /> },
  { path: "/user-activity", element: <UserActivity /> },
  { path: "/user-status", element: <UserStatus /> },
  { path: "/change-password", element: <ChangePasswordMain /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/no-direct-email", element: <Welcome /> },
  { path: "/user-account-history", element: <UserAccountHistory /> },
  { path: "/system-outage", element: <SystemOutage /> },
  { path: "/unscheduled-outage", element: <UnscheduledOutage /> },
  { path: "/scheduled-outage", element: <ScheduledOutage /> },
  { path: "/request-not-found", element: <RequestNotFound /> },
  { path: "/experian-results", element: <ExperianResults /> },
  { path: "/experian-sso", element: <ExperianSSO /> },
  { path: "/notify-app", element: <NotifyApp /> },
  { path: "/sys-admin-registration", element: <RegistrationSysAdmin /> },
  {
    path: "/success-sysadmin-registration",
    element: <SuccessSysAdminRegistration />,
  },
];

export default AppRoutes;
